import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Megaphone } from "lucide-react";
import api from "@/lib/api";

function useCountdown(target) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!target) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [target]);
  if (!target) return null;
  const end = new Date(target).getTime();
  if (isNaN(end)) return null;
  const diff = end - now;
  if (diff <= 0) return { expired: true };
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { expired: false, d, h, m, s };
}

const Seg = ({ v, label }) => (
  <span className="inline-flex flex-col items-center leading-none">
    <span className="font-bold tabular-nums text-sm">{String(v).padStart(2, "0")}</span>
    <span className="text-[9px] uppercase opacity-70">{label}</span>
  </span>
);

export default function PromoBanner() {
  const [ann, setAnn] = useState(null);
  const [dismissed, setDismissed] = useState(true);
  const cd = useCountdown(ann?.countdown_until);

  useEffect(() => {
    api.get("/settings/announcement").then(({ data }) => {
      if (data.enabled && data.message) {
        setAnn(data);
        setDismissed(localStorage.getItem("hbc_promo_dismissed") === data.message);
      }
    }).catch(() => {});
  }, []);

  if (!ann || dismissed) return null;

  const close = () => { localStorage.setItem("hbc_promo_dismissed", ann.message); setDismissed(true); };

  return (
    <div className="w-full bg-[#19324A] text-white" data-testid="promo-banner">
      <div className="max-w-6xl mx-auto pl-4 pr-10 py-1.5 sm:py-2 flex items-center justify-center gap-x-3 gap-y-0 text-center relative flex-wrap">
        <Megaphone className="w-4 h-4 text-[#FFD93D] shrink-0 hidden sm:block" />
        <span className="text-[13px] sm:text-sm font-semibold" data-testid="promo-banner-message">{ann.message}</span>
        {cd && !cd.expired && (
          <span className="inline-flex items-center gap-2 bg-white/10 rounded-full px-3 py-1" data-testid="promo-banner-countdown">
            {cd.d > 0 && <Seg v={cd.d} label="days" />}
            <Seg v={cd.h} label="hrs" />
            <Seg v={cd.m} label="min" />
            <Seg v={cd.s} label="sec" />
          </span>
        )}
        {ann.cta_label && ann.cta_link && (
          <Link to={ann.cta_link} className="text-[13px] sm:text-sm font-bold text-[#FFD93D] underline shrink-0 py-1.5 px-1" data-testid="promo-banner-cta">{ann.cta_label}</Link>
        )}
        <button onClick={close} aria-label="Dismiss" data-testid="promo-banner-close"
          className="absolute right-1 p-2.5 rounded-full hover:bg-white/10"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
